'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var reactUtils = require('@chakra-ui/react-utils');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var useAccordion = require('./useAccordion.js');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["htmlProps"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var _createContext = reactUtils.createContext({
    name: 'AccordionItemContext',
    errorMessage: 'useAccordionItemContext: `context` is undefined. Seems you forgot to wrap the accordion item parts in `<AccordionItem />` '
  }),
  _createContext2 = _slicedToArray__default["default"](_createContext, 2),
  AccordionItemProvider = _createContext2[0],
  useAccordionItemContext = _createContext2[1];
/**
 * AccordionItem
 *
 * Ssingle accordion that provides the open-close behavior when the accordion
 * button is clicked.
 *
 * It also provides context for the accordion button and panel.
 */
var AccordionItem = react.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className;
  var _useAccordionItem = useAccordion.useAccordionItem(props),
    htmlProps = _useAccordionItem.htmlProps,
    context = _objectWithoutProperties__default["default"](_useAccordionItem, _excluded);
  var styles = react.useStyles();
  var containerStyles = _objectSpread(_objectSpread({}, styles.item), {}, {
    overflowAnchor: 'none'
  });
  var ctx = React__default["default"].useMemo(function () {
    return context;
  }, [context]);
  return /*#__PURE__*/React__default["default"].createElement(AccordionItemProvider, {
    value: ctx
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, htmlProps, {
    className: utils.cx('chakra-accordion__item', className),
    __css: containerStyles
  }), utils.runIfFn(children, {
    isExpanded: !!context.isOpen,
    isDisabled: !!context.isDisabled
  })));
});
AccordionItem.displayName = 'AccordionItem';

/**
 * React hook to get the state and actions of an accordion item
 */
function useAccordionItemState() {
  var _useAccordionItemCont = useAccordionItemContext(),
    isOpen = _useAccordionItemCont.isOpen,
    isDisabled = _useAccordionItemCont.isDisabled,
    onClose = _useAccordionItemCont.onClose,
    onOpen = _useAccordionItemCont.onOpen;
  return {
    isOpen: isOpen,
    onClose: onClose,
    isDisabled: isDisabled,
    onOpen: onOpen
  };
}
exports.AccordionItem = AccordionItem;
exports.AccordionItemProvider = AccordionItemProvider;
exports.useAccordionItemContext = useAccordionItemContext;
exports.useAccordionItemState = useAccordionItemState;